<template>
  <div class="input-group date p-l-0 p-r-0 m-b-10" ref="wrapper" :id="id">
    <label v-show="labelText" class="label--datetime">{{ labelText }}</label>
    <input :disabled="disabled"
           :readonly="readonly"
           type="text"
           class="form-control"
           :value="inputValue"
           ref="input">
    <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
  </div>
</template>

<script>
import moment from 'moment'

const defaultDateFormat = 'DD/MM/YYYY'
const dateFormatRegex = /^\d{2}\/\d{2}\/\d{4}$/
const datepickerDefaultOptions = {
  language: 'fr',
  autoclose: true,
  format: 'dd/mm/yyyy',
  startDate: new Date(),
  toggleActive: false,
  orientation: 'top'
}

export default {
  name: "date-picker",
  props: {
    labelText: String,
    value: String,
    datepickerOptions: null,
    id: null,
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: true
    },
    beginningOfDay: {
      type: Boolean,
      default: false
    },
    endOfDay: {
      type: Boolean,
      default: false
    },
    disabledToday: Boolean
  },
  data: function(){
    return {
      inputValue: null
    }
  },
  watch: {
    value: function(newValue, _) {
      this.setInputValue(newValue)
      this.setDatePicker(newValue)
    }
  },
  methods: {
    updateValue() {
      let value = this.transformValue(this.$refs.input.value);
      this.$emit('input', value, this.$refs.wrapper.id);
    },
    setInputValue(value) {
      let date;

      if (value === null || value === '') {
        this.inputValue = value;
        return;
      }

      date = moment(value, defaultDateFormat)

      if (date.isValid()) {
        this.inputValue = date.format(defaultDateFormat)
      } else {
        this.inputValue = value;
      }
    },
    transformValue(value) {
      if (value === null || value === '') return value;

      let date = moment(value, defaultDateFormat);
      if (!date.isValid()) return value;

      if (this.beginningOfDay) {
        return date.startOf('day').format();
      } else if (this.endOfDay) {
        return date.endOf('day').format();
      } else {
        return value;
      }
    },
    buildDatepickerOptions() {
      let options = datepickerDefaultOptions;

      if (this.datepickerOptions) {
        options = $.extend(options, this.datepickerOptions)
      }

      if (this.disabledToday) {
        delete options.startDate;
        options.endDate = new Date(Date.now() - 1000*60*60*24) // yesterday
      } else {
        delete options.endDate;
        options.startDate = new Date()
      }

      return options;
    },
    initDatePicker() {
      const datepickerOptions = this.buildDatepickerOptions();

      $(this.$el)
        .datepicker(datepickerOptions)
        .on("changeDate clearDate", this.updateValue)
    },
    setDatePicker(value) {
      const datepicker = $(this.$el).data('datepicker');
      if (datepicker) {
        datepicker.setDate(value);
      }
    }
  },
  mounted: function(){
    this.setInputValue(this.value);
    this.initDatePicker();

    if (this.value && this.value.length !== 0) {
      this.setDatePicker(this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/DatePicker.vue